var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgAnonymousGrave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_21173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_21173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 35,
    r: 6,
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 25L51.7321 28H48.2679L50 25Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 45L48.2679 42L51.7321 42L50 45Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 35L57 36.7321L57 33.2679L60 35Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 35L43 33.2679L43 36.7321L40 35Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0711 42.0714L53.7251 41.1749L56.1746 38.7254L57.0711 42.0714Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9289 27.9286L46.2749 28.8251L43.8254 31.2746L42.9289 27.9286Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9286 42.0711L43.8251 38.7251L46.2746 41.1746L42.9286 42.0711Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0714 27.9289L56.1749 31.2749L53.7254 28.8254L57.0714 27.9289Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 75,
    width: 100,
    height: 31,
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3689 82.9332C0.185246 85.8935 -5.28689 76.0038 -7 70.1889V49H107C103.73 65.035 92.5 107 82.7049 83.9332C79.2012 75.6823 60.4778 89.7481 51.4672 81.8187C44.9262 76.0626 38.123 80.3293 20.3689 82.9332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 81C2.9 83.8 -6.16667 73.5 -8 68V34.5H114C110.5 49.6667 105 92 88 81C80.2595 75.9915 63.1429 86.5 53.5 79C46.5 73.5556 43.5 78.537 24.5 81Z",
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 52.2917C72.4943 51.0722 75.1237 54.0548 77.9944 54.3058C79.0572 54.4044 79.9866 54.1703 81 53.867C79.2011 55.2344 77.4022 55.2436 75.5449 54.5322C73.3173 53.6499 72.0776 52.3718 69 52.2917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 74.4681C32.7511 74.407 35.3656 74.5085 37.2703 72.7672C37.697 72.3781 37.9132 72.0502 38 72C37.9701 72.0355 37.9474 72.2239 37.8393 72.4895C36.8378 75.0102 32.9218 75.5572 30 74.4681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 37.3612C48.0795 36.923 49.1135 36.928 50.0823 37.1406C51.5506 37.4825 51.8798 37.9158 53.8581 37.8889C52.526 38.5031 51.3538 38.0758 50.3709 37.8035C48.8013 37.3414 48.0851 37.397 47 37.3612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 70.6003C60.574 69.872 62.0818 69.8803 63.4944 70.2337C65.6354 70.8017 66.1155 71.5217 69 71.4771C67.0577 72.4977 65.3485 71.7876 63.9152 71.3351C61.6266 70.5673 60.5823 70.6597 59 70.6003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 43.287C86.913 44.1704 88.93 44.7091 90.4901 42C90.0956 44.6455 86.9167 45.5399 84 43.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 43.043C13.0004 44.2392 15.2131 45.254 17.5418 45.0988C19.1956 44.9731 22.0634 44.2455 23.5828 43.6496C22.436 44.6582 19.7652 45.8219 17.3708 46.0003C16.1607 46.0102 14.9633 45.7505 13.8626 45.2396C12.7619 44.7286 11.7848 43.9788 11 43.043H11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 63C92.5898 63.809 94.3483 64.4951 96.199 64.3902C97.5133 64.3052 99.7925 63.8131 101 63.4102C100.089 64.0922 97.966 64.8792 96.0631 64.9998C95.1014 65.0065 94.1498 64.8309 93.275 64.4854C92.4003 64.1399 91.6237 63.6329 91 63V63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 53.5791C28.3776 54.2416 31.0071 52.51 32.7678 52.1826C36.2449 51.4068 37.7673 53.2998 39.5601 54.1687C40.2606 54.4515 41.0191 54.5544 41.7681 54.468C42.5172 54.3817 43.2337 54.1088 43.8541 53.6737C43.1425 54.6155 41.3666 55.3603 39.4746 54.8731C37.7093 54.3968 36.2678 52.2649 32.6594 53.0671C30.7384 53.5046 27.9454 54.7148 26 53.5791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 38.0434C71.8644 38.4812 73.9263 37.337 75.3069 37.1207C78.0334 36.6081 79.2272 37.8589 80.6329 38.433C81.1823 38.6199 81.777 38.6878 82.3643 38.6308C82.9517 38.5737 83.5135 38.3934 84 38.1059C83.442 38.7282 82.0494 39.2204 80.5659 38.8984C79.1817 38.5837 78.0513 37.175 75.2219 37.7051C73.7155 37.9942 71.5255 38.7939 70 38.0434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 69.5791C69.3776 70.2416 72.0071 68.51 73.7678 68.1826C77.2449 67.4068 78.7673 69.2998 80.5601 70.1687C81.2606 70.4515 82.0191 70.5544 82.7681 70.468C83.5172 70.3817 84.2337 70.1088 84.8541 69.6737C84.1425 70.6155 82.3666 71.3603 80.4746 70.8731C78.7093 70.3968 77.2678 68.2649 73.6594 69.0671C71.7384 69.5046 68.9454 70.7148 67 69.5791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 51.7855C43.4232 50.8763 44.9945 49.8507 47.65 50.7305C50.0047 51.5543 51.1729 52.1471 52.3655 51.739C54.198 51.1059 53.5871 49.4116 52.4678 49.455C51.8402 49.4721 51.3241 50.099 51.857 50.898C50.6354 49.8243 52.4037 48.2929 53.6452 49.3635C54.4759 50.0757 54.4346 51.5031 53.2023 52.2495C50.22 54.0214 47.6684 50.4108 44.0768 51.1354C43.2812 51.2906 42.5192 51.6304 42 51.7855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 68.2317C2.16578 67.5033 3.45289 66.6816 5.6281 67.3864C7.55689 68.0465 8.51378 68.5214 9.49069 68.1944C10.9917 67.6872 10.4914 66.3298 9.57449 66.3646C9.0604 66.3782 8.63762 66.8805 9.07416 67.5207C8.07349 66.6604 9.52196 65.4335 10.5389 66.2912C11.2193 66.8618 11.1856 68.0055 10.1761 68.6034C7.73326 70.023 5.64311 67.1303 2.70114 67.7109C2.04945 67.8352 1.42528 68.1074 1 68.2317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 41.2317C79.1658 40.5033 80.4529 39.6816 82.6281 40.3864C84.5569 41.0465 85.5138 41.5214 86.4907 41.1944C87.9917 40.6872 87.4914 39.3298 86.5745 39.3646C86.0604 39.3782 85.6376 39.8805 86.0742 40.5207C85.0735 39.6604 86.522 38.4335 87.5389 39.2912C88.2193 39.8618 88.1856 41.0055 87.1761 41.6034C84.7333 43.023 82.6431 40.1303 79.7011 40.7109C79.0495 40.8352 78.4253 41.1074 78 41.2317Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAnonymousGrave);
export default __webpack_public_path__ + "static/media/imgAnonymousGrave.b8a9e144d0e8157fd4509e8f169b71db.svg";
export { ForwardRef as ReactComponent };